const formatMoney = (input: number) => {
  return `$${input.toFixed(2)}`;
};

const formatNumber = (input: number) => {
  return `${input.toFixed(2)}`;
};

export { formatMoney, formatNumber };
